import { useMemo } from 'react';
import { compactArray } from '@mews/fp';
import { getCompanies, getCustomers } from '@mews-commander/legacy-entities/src/ducks';
import { getBills } from '@mews-commander/legacy-entities/src/ducks/bills';
import { useCommanderSelector } from '@mews-commander/utils';

export const useFilteredAccounts = ({
    accountIds,
    search,
}: {
    accountIds: string[];
    groupId: string;
    search: string;
}) => {
    const customers = useCommanderSelector(getCustomers);
    const companies = useCommanderSelector(getCompanies);
    const bills = useCommanderSelector(getBills);

    return useMemo(() => {
        const searchRegexes = search
            .trim()
            .split(' ')
            .map((s) => new RegExp(s.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i'));

        return accountIds.filter((id) => {
            const customer = customers[id];
            const company = companies[id];
            const accountBills = Object.values(bills).filter((b) => b.ownerId === id);

            return searchRegexes.every((regex) =>
                compactArray([
                    id,
                    ...(customer ? [customer.firstName, customer.lastName] : []),
                    ...(company ? [company.name] : []),
                    ...accountBills.map((b) => b.name),
                ]).some((value) => (value ? regex.test(value) : false))
            );
        });
    }, [accountIds, search, customers, companies, bills]);
};
